import {hostName} from "../../../endpoint";
import {defaultHeaders} from "../../../headers";

export const changePassword = async (changePassword) => {
  try {
    const result = await fetch(`${hostName}/business/account-change-password`, {
      method: "POST",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(changePassword),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
